export default __webpack_public_path__ + "static/media/Erin 9781408303511.a89df0f4.jpg";